import filter from 'lodash/filter';
import * as actions from './actions';
import { GET_YEAR_GROUPS_SUCCESS } from '../school-roll/actions';

const initialState = {
    yearGroups: [],
    searchTerm: '',
    userClassroomRelation: { classrooms: [] },
    isLoadingClassroomDetail: true,
    isLoadingYearGroupDetail: true,
    isLoadingClassroomTeacherMapping: false,
    selectedYearGroup: -1,
    disableAssignSaveButton: true,
    disableAssignCancelButton: false,
    showAssignUserConfirmationModal: false,
    isSaveInProgress: false
};

export const filterGroups = (data, searchTerm) => {
    const groups = filter(data, (item) => {
        if (item.name.indexOf(searchTerm) !== -1) {
            return item;
        }

        filter(item.assignedTeachersName, (teacher) => {
            if (teacher.indexOf(searchTerm) !== -1) {
                return item;
            }
            filter(item.groups, (group) => {
                if (group.name.indexOf(searchTerm) !== -1 || group.courseName.indexOf(searchTerm) !== -1) {
                    return item;
                }
                return false;
            });
            return false;
        });
        return false;
    });

    return groups;
};

function assignUserReducer(state = initialState, action) {
    switch (action.type) {
    case GET_YEAR_GROUPS_SUCCESS:
        return { ...state, yearGroups: action.yearGroups };

    case actions.UPDATE_ASSIGN_STUDENT_SEARCH_TERM:
    {
        const filteredGroups = filterGroups(state.classrooms, action.searchTerm);
        return { ...state, filteredGroups, searchTerm: action.searchTerm };
    }

    case actions.UPDATE_SELECTED_YEAR_GROUP:
        return { ...state, selectedYearGroup: Number(action.selectedYearGroup) };

    case actions.GET_STUDENT_CLASSROOMS_RELATION_REQUEST:
        return { ...state, isLoadingClassroomDetail: true, yearGroupEnum: -2, searchTerm: '' };

    case actions.GET_STUDENT_CLASSROOMS_RELATION_SUCCESS:
        return { ...state, userClassroomRelation: action.classrooms, isLoadingClassroomDetail: false, yearGroupEnum: action.classrooms.yearGroupEnum };

    case actions.GET_STUDENT_CLASSROOMS_RELATION_FAILURE:
        return { ...state, isLoadingClassroomDetail: false };

    case actions.UPDATE_CLASSROOM_REQUEST:
        return { ...state, disableAssignSaveButton: false };

    case actions.ASSIGN_STUDENT_REQUEST:
        return { ...state, disableAssignSaveButton: true, disableAssignCancelButton: true, isSaveInProgress: action.isSaveInProgress };

    case actions.ASSIGN_STUDENT_SUCCESS:
        return { ...state, showAssignUserConfirmationModal: true, disableAssignSaveButton: false, disableAssignCancelButton: false, isSaveInProgress: action.isSaveInProgress };

    case actions.ASSIGN_STUDENT_FAILURE:
        return { ...state, disableAssignSaveButton: false, disableAssignCancelButton: false, isSaveInProgress: action.isSaveInProgress };

    case actions.CLOSE_ASSIGN_CONFIRMATION_MODAL_REQUEST:
        return { ...state, showAssignUserConfirmationModal: false, disableAssignSaveButton: true };

    case actions.RESET_USER_CLASSROOM_RELATION:
        return { ...state, userClassroomRelation: { classrooms: [] }, disableAssignSaveButton: true };

    case actions.GET_TEACHER_CLASSROOMS_RELATION_REQUEST:
        return { ...state, isLoadingClassroomDetail: true, yearGroupEnum: -2, searchTerm: '' };

    case actions.GET_TEACHER_CLASSROOMS_RELATION_SUCCESS:
        return { ...state, userClassroomRelation: action.classrooms, isLoadingClassroomDetail: false, yearGroupEnum: -1 };

    case actions.GET_TEACHER_CLASSROOMS_RELATION_FAILURE:
        return { ...state, isLoadingClassroomDetail: false };

    case actions.ASSIGN_TEACHER_REQUEST:
        return { ...state, disableAssignSaveButton: true, disableAssignCancelButton: true, isSaveInProgress: action.isSaveInProgress };

    case actions.ASSIGN_TEACHER_SUCCESS:
        return { ...state, showAssignUserConfirmationModal: true, disableAssignSaveButton: false, disableAssignCancelButton: false, isSaveInProgress: action.isSaveInProgress };

    case actions.ASSIGN_TEACHER_FAILURE:
        return { ...state, disableAssignSaveButton: false, disableAssignCancelButton: false, isSaveInProgress: action.isSaveInProgress };

    case actions.CLASSROOM_TEACHER_MAPPING_SUCCESS:
    {
        return { ...state, isLoadingClassroomTeacherMapping: true, disableAssignSaveButton: true };
    }

    case actions.ASSIGN_TEACHER_TO_CLASSROOM_REQUEST:
        return { ...state, disableAssignSaveButton: true, disableAssignCancelButton: true, isSaveInProgress: action.isSaveInProgress };

    case actions.ASSIGN_TEACHER_TO_CLASSROOM_SUCCESS:
        return { ...state, disableAssignSaveButton: false, disableAssignCancelButton: false, isSaveInProgress: action.isSaveInProgress, isLoadingClassroomTeacherMapping: false };

    case actions.ASSIGN_TEACHER_TO_CLASSROOM_FAILURE:
        return { ...state, disableAssignSaveButton: false, disableAssignCancelButton: false, isSaveInProgress: action.isSaveInProgress };

    default:
        return state;
    }
}

export default assignUserReducer;



// WEBPACK FOOTER //
// ./app/containers/assign-user/reducer.js